import type { AuthSuccess } from './auth-results';

/**
 * The server said yes to a sign-in step, but the legacy token (the Java API
 * credential) could not be fetched, even after one retry.
 *
 * The user is NOT signed out: their session cookie is good. `result` is the
 * server's answer, so a caller can still use it, for example to show the
 * one-time `backupCodes` from MFA setup before sending the user to log in.
 */
export class LegacyTokenError extends Error {
  readonly result: AuthSuccess;

  constructor(result: AuthSuccess) {
    super('Signed in, but the legacy token could not be fetched');
    this.name = 'LegacyTokenError';
    this.result = result;
  }
}
